export const platform = {
  routes: [
    {
      path: "/",
      component: () => import("../wellcome-dashboard"),
    },
  ],
};
